import { useOrganizationContext } from "context/OrganisationContext";
import { useRoomTemplateLoginPageContext } from "context/RoomTemplateContext";
import { useLoginContent } from "localization/utils";
import Helmet from "react-helmet";

const MetaTags = () => {
	const org = useOrganizationContext();
	const { value: roomTemplate } = useRoomTemplateLoginPageContext();
	const description = useLoginContent({
		contentId: roomTemplate?.loginContent?.headerContent,
		orgSlug: org?.value?.slug,
	});

	const title = org.value?.name || "Riddlestory";
	const url = "https://play.riddlestory.com";
	const image = org.value?.logoURI;

	return (
		<Helmet>
			<title>{title}</title>
			<meta name="title" content={title} />
			<meta property="og:title" content={title} />
			<meta name="description" content={description} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={image} />
			<meta property="og:url" content={url} />
			<meta property="og:type" content="website" />
			<meta property="twitter:url" content={url} />
			<meta property="twitter:title" content={title} />
			<meta property="twitter:description" content={description} />
			<meta property="twitter:image" content={image} />
		</Helmet>
	);
};

export default MetaTags;
